import cx from "classnames";
import React from "react";

import ArticlePreview from "@/components/ArticlePreview";
import { isWebshopClosed } from "@/utils/helpers";

import styles from "./styles.module.css";

export type ArticlesFullListProps = {
  className?: string;
};

export const ArticlesFullListNO = ({ className }: ArticlesFullListProps) => {
  return (
    <ul className={cx(styles.productsList, className)}>
      <ArticlePreview
        key="hva-er-sirkulaer-okonomi"
        as="li"
        imgSrc="/assets/plastic-bottle.jpg"
        link="/hva-er-pafyll/sirkulaer-okonomi/hva-er-sirkulaer-okonomi"
        title="Sirkulær økonomi er løsningen"
        className={styles.productItem}
        subTitle="Bærekraft"
      />
      {isWebshopClosed ? null : (
        <ArticlePreview
          key="om-pafyll"
          as="li"
          imgSrc="/assets/pafyll-in-box.png"
          link="/hva-er-pafyll/om-pafyll/grunnleggeren-pafyll"
          title="Møt grunnleggeren: Bård"
          className={styles.productItem}
          subTitle="Om På(fyll)™"
        />
      )}
      <ArticlePreview
        key="hvordan-funker-det"
        as="li"
        imgSrc="/assets/pafyll-container.png"
        link="/hva-er-pafyll/om-pafyll/hvordan-fungerer-det/slik-fungerer-pafyll-fra-a-til-a"
        title="Hvordan funker det?"
        className={styles.productItem}
        subTitle="Hva er På(fyll)™"
      />
    </ul>
  );
};

export const ArticlesFullListEN = ({ className }: ArticlesFullListProps) => {
  return (
    <ul className={cx(styles.productsList, className)}>
      <ArticlePreview
        key="hva-er-sirkulaer-okonomi"
        as="li"
        imgSrc="/assets/plastic-bottle.jpg"
        link="/hva-er-pafyll/sirkulaer-okonomi/hva-er-sirkulaer-okonomi"
        title="Circular economy is the solution"
        className={styles.productItem}
        subTitle="Sustainability"
      />
      {isWebshopClosed ? null : (
        <ArticlePreview
          key="om-pafyll"
          as="li"
          imgSrc="/assets/pafyll-in-box.png"
          link="/hva-er-pafyll/om-pafyll/grunnleggeren-pafyll"
          title="Meet the founder: Bård"
          className={styles.productItem}
          subTitle="About På(fyll)™"
        />
      )}
      <ArticlePreview
        key="hvordan-funker-det"
        as="li"
        imgSrc="/assets/pafyll-container.png"
        link="/hva-er-pafyll/om-pafyll/hvordan-fungerer-det/slik-fungerer-pafyll-fra-a-til-a"
        title="How does it work?"
        className={styles.productItem}
        subTitle="What is På(fyll)™"
      />
    </ul>
  );
};
